// See https://www.chartjs.org/docs/latest/charts/area.html for others you might
// implement in time.
export var ChartType;
(function (ChartType) {
    ChartType["Line"] = "line";
    ChartType["Bar"] = "bar";
    ChartType["Scatter"] = "scatter";
})(ChartType || (ChartType = {}));
export var ChartRatios;
(function (ChartRatios) {
    ChartRatios["Ratio1x1"] = "ratio-1x1";
    ChartRatios["Ratio4x3"] = "ratio-4x3";
    ChartRatios["Ratio16x9"] = "ratio-16x9";
    ChartRatios["Ratio21x9"] = "ratio-21x9";
})(ChartRatios || (ChartRatios = {}));
